module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7ejRt"))).then(() => module.bundle.root('ewmtE'));